import { Link } from "react-router-dom";
import { FiPlus } from "react-icons/fi";

import { useContext, useEffect, useState } from "react";

import { ItemPagination } from "../../components/ItemPagination";
import { api } from "../../services/api";
import { AuthContext, useAuth } from "../../contexts/AuthContext";
import { PageTitle } from "../../components/PageTitle";
import { EmptyState } from "../../components/EmptyState";
import { CanAccess } from "../../components/CanAccess";

interface User {
  id: string;
  name: string;
  occupation: string;
  status: string;
  avatar_url: string | null;
}

export function Users() {
  const { user } = useContext(AuthContext);
  const { hasPermission } = useAuth();
  const [users, setUsers] = useState<User[]>([]);
  const [changeStatus, setChangeStatus] = useState<number>(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api
      .get("/users")
      .then(response => {
        setUsers(response.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [changeStatus]);

  async function handleChangeStatus(id: string, newStatus: string) {
    api.patch(`users/status/${id}/${newStatus === "A" ? "I" : "A"}`);
    setTimeout(() => {
      setChangeStatus(changeStatus + 1);
    }, 1000);
  }

  return (
    <div className="container mx-auto">
      <PageTitle title="Usuários" backButton backPath="/home" />
      <div className="flex items-start justify-between mb-6">
        <CanAccess permission="users:create" allowAdmin>
          <Link
            to="/users/new"
            className="group bg-[#0085BD] text-white w-12 h-12 rounded-full flex items-center justify-center shadow-lg hover:bg-[#006a96] transition-all duration-200 hover:shadow-xl"
          >
            <FiPlus size={24} className="text-white transition-transform duration-200 group-hover:rotate-90" />
          </Link>
        </CanAccess>
      </div>
      <div className="space-y-2">
        {loading && (
          <div className="flex items-center justify-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0085BD]" />
          </div>
        )}
        {!loading &&
          users.length > 0 &&
          users.map(({ id, name, occupation, status, avatar_url }: User) => (
            <ItemPagination
              key={id}
              title={name}
              id={id}
              status={status}
              description={occupation}
              avatarUrl={avatar_url}
              hasDelete
              canEdit={hasPermission("users:update") || user?.isAdmin}
              canDelete={hasPermission("users:delete") || user?.isAdmin}
              handleChangeStatus={() => handleChangeStatus(id, status)}
            />
          ))}
        {!loading && users.length === 0 && (
          <div className="col-span-full">
            <EmptyState type="users" />
          </div>
        )}
      </div>
    </div>
  );
}
